import { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import { setCurrentPathname } from 'src/services/httpServiceManager';
import LoadingScreen from 'src/componentes/LoadingScreen';
import { clearReturnUrl, readReturnUrl, saveReturnUrl } from './returnUrl';

import useAuth from '../hooks/useAuth';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, utilizandoAdfs, isApp, isLogout } = useAuth();

  const location = useLocation();
  const windowLocation = window.location;
  const currentUrl = `${location.pathname}${location.search}`;
  const [returnUrl, setReturnUrl] = useState(readReturnUrl);
  const [savedLocation, setSavedLocation] = useState(null);

  useEffect(() => {
    if (isAuthenticated) {
      clearReturnUrl();
      setReturnUrl(null);
      return;
    }
    const createdAt = saveReturnUrl(currentUrl);
    setReturnUrl(null);
    setSavedLocation({ url: currentUrl, createdAt });
  }, [isAuthenticated, currentUrl]);

  useEffect(() => {
    if (!isAuthenticated) return;

    if (
      (windowLocation?.pathname?.toUpperCase() == '/LOGOUT' ||
        windowLocation?.pathname?.toUpperCase() == '/REDIRECT-TO-APP') &&
      isApp &&
      utilizandoAdfs
    ) {
      window.location.href = 'actioapp://main';
    }
  }, [windowLocation, isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) return;
    setCurrentPathname(location.pathname);
  }, [location.pathname, isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname, isAuthenticated]);

  if (!isAuthenticated) {
    if (savedLocation?.url !== currentUrl) return <LoadingScreen />;
    return utilizandoAdfs && isLogout ? (
      <Redirect to={{ pathname: '/logout' }} />
    ) : (
      <Redirect
        to={{
          pathname: '/login',
          state: {
            from: location,
            returnUrlCreatedAt: savedLocation.createdAt,
          },
        }}
      />
    );
  }

  if (returnUrl && returnUrl !== currentUrl) return <Redirect to={returnUrl} />;

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
